import React from 'react';

import { Backdrop } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import styles from './StlModal.module.css';

interface StlModalProps {
  title: string;
  descr: string;
  upper?: React.ReactNode;
  lower?: React.ReactNode;
}

export default function StlModal({
  title,
  descr,
  upper,
  lower,
}: StlModalProps) {
  return (
    <Backdrop aria-labelledby="modal" className={styles.backdrop} open>
      <Box className={styles.modal}>
        <div className={styles.modal_content}>
          {upper}
          <div className={styles.modal_txt}>
            <Typography className={styles.modal_title} variant="body2">
              {title}
            </Typography>
            <Typography
              className={styles.modal_descr}
              variant="caption"
              sx={{ mt: 2 }}
            >
              {descr}
            </Typography>
          </div>
          {lower}
        </div>
      </Box>
    </Backdrop>
  );
}
